import { useCallback, useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

const CLS = { conforme: "bg-emerald-500/20 text-emerald-300", a_acheter: "bg-rose-500/20 text-rose-300", a_remplacer: "bg-orange-500/20 text-orange-300",
  prete_dojo: "bg-sky-500/20 text-sky-300", deja_possede: "bg-emerald-500/10 text-emerald-200", non_requis: "bg-zinc-700 text-zinc-300", a_valider: "bg-violet-500/20 text-violet-300" };

// Admin : « Vérifier l'équipement de l'élève » — statut par article (Conforme / À acheter / À remplacer / Prêté / Déjà possédé / Non requis / À valider).
export function StudentEquipmentCheck({ contractId, onClose }) {
  const [data, setData] = useState(null);
  const [statuses, setStatuses] = useState([]);
  const load = useCallback(async () => {
    try { const [a, m] = await Promise.all([api.get(`/program-equipment/student/${contractId}`), api.get("/program-equipment/meta")]); setData(a.data); setStatuses(m.data.student_statuses); }
    catch { toast.error("Impossible de charger l'équipement"); }
  }, [contractId]);
  useEffect(() => { load(); }, [load]);

  const set = async (item, status) => {
    const note = status === "a_valider" || status === "prete_dojo" ? window.prompt("Note (facultatif)", item.student_note || "") ?? "" : item.student_note || "";
    try { await api.post(`/program-equipment/student/${contractId}/status`, { item_id: item.id, status, note }); load(); } catch { toast.error("Erreur"); }
  };
  if (!data) return null;
  const label = (k) => statuses.find((s) => s.key === k)?.label || "—";

  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4" data-testid="student-equipment-check">
      <div className="bg-zinc-900 border border-zinc-700 rounded-xl w-full max-w-3xl p-5 max-h-[90vh] overflow-y-auto space-y-3">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-semibold">Vérifier l'équipement — {data.contract.full_name}</h3>
            <p className="text-xs text-zinc-400">{data.program_label} · Obligatoire conforme : <b data-testid="sec-progress">{data.progress.conforme}/{data.progress.total}</b></p>
          </div>
          <button onClick={onClose} className="text-zinc-400 hover:text-white" data-testid="sec-close">✕</button>
        </div>
        {data.groups.map((g) => g.items.length > 0 && (
          <div key={g.category}>
            <div className={`text-xs font-bold uppercase mb-1 ${g.category === "obligatoire" ? "text-rose-300" : g.category === "recommande" ? "text-amber-300" : "text-sky-300"}`}>{g.label}</div>
            <div className="space-y-1">
              {g.items.map((it) => (
                <div key={it.id} className="flex flex-wrap items-center gap-2 text-xs bg-zinc-950/60 rounded px-2 py-1.5" data-testid={`sec-item-${it.id}`}>
                  <span className="font-medium text-zinc-100">{it.label}</span>
                  {it.sizes?.length > 0 && <span className="text-zinc-500">📏 {it.sizes.join(", ")}</span>}
                  {it.instructor_validation && <span className="text-sky-300">· validation instructeur</span>}
                  <span className={`px-1.5 py-0.5 rounded ${CLS[it.student_status] || "bg-zinc-800 text-zinc-400"}`} data-testid={`sec-current-${it.id}`}>{it.student_status ? label(it.student_status) : "non vérifié"}</span>
                  {it.student_note && <span className="text-zinc-500 italic">« {it.student_note} »</span>}
                  <select value={it.student_status || ""} onChange={(e) => e.target.value && set(it, e.target.value)} className="ml-auto bg-zinc-950 border border-zinc-700 rounded px-1 py-0.5" data-testid={`sec-select-${it.id}`}>
                    <option value="">— marquer —</option>
                    {statuses.map((s) => <option key={s.key} value={s.key}>{s.label}</option>)}
                  </select>
                </div>
              ))}
            </div>
          </div>
        ))}
        {data.todo_before_next_class.length > 0 && <p className="text-xs text-amber-300" data-testid="sec-todo">À régler avant le prochain cours : {data.todo_before_next_class.join(" · ")}</p>}
      </div>
    </div>
  );
}
